/**
 * Ask the active service worker to drop cached per-user photo/receipt blobs.
 * Best-effort — failures are logged for debuggability but never surfaced to the user
 * (we still want logout to proceed even if the SW is unreachable).
 */
export async function clearServiceWorkerImageCache() {
  if (typeof navigator === "undefined" || !navigator.serviceWorker) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const worker = reg.active || navigator.serviceWorker.controller;
    worker?.postMessage({ type: "TV_CLEAR_IMG_CACHE" });
  } catch (err) {
    console.debug("[auth] SW cache clear failed:", err?.message || err);
  }
}
